import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import {
  AssignmentDto,
  CreateOrUpdateAllowIPDto,
  TypeDto,
} from "../../../types/adminSetting";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminSettingApi {
  getManageType(): Promise<TypeDto[]>;
  createManageType(inputOptions: TypeDto): Promise<TypeDto>;
  updateManageType(inputOptions: TypeDto): Promise<TypeDto>;
  deleteManageType(codes: string[]): Promise<string[]>;
  getAssingment(): Promise<AssignmentDto[]>;
  createAssingment(
    reqeuestOption: CreateOrUpdateAllowIPDto
  ): Promise<AssignmentDto>;
  updateAssingment(
    reqeuestOption: CreateOrUpdateAllowIPDto
  ): Promise<AssignmentDto>;
  deleteAssingment(deleteIds: string[]): Promise<AssignmentDto[]>;
}

class AdminLoginServerApi implements AdminSettingApi {
  async getManageType(): Promise<TypeDto[]> {
    const resp = await axiosAdmin.get<TypeDto[]>(
      `${GATEWAY_URL}/wapi/admins/manage/type`
    );
    return Promise.resolve(resp.data);
  }
  async createManageType(option: TypeDto): Promise<TypeDto> {
    const resp = await axiosAdmin.post<TypeDto>(
      `${GATEWAY_URL}/wapi/admins/manage/type/create`,
      option
    );
    return Promise.resolve(resp.data);
  }
  async updateManageType(option: TypeDto): Promise<TypeDto> {
    const resp = await axiosAdmin.post<TypeDto>(
      `${GATEWAY_URL}/wapi/admins/manage/type/update`,
      option
    );
    return Promise.resolve(resp.data);
  }
  async deleteManageType(codes: string[]): Promise<string[]> {
    const resp = await axiosAdmin.post<string[]>(
      `${GATEWAY_URL}/wapi/admins/manage/type/delete`,
      codes
    );
    return Promise.resolve(resp.data);
  }
  async getAssingment(): Promise<AssignmentDto[]> {
    const resp = await axiosAdmin.get<AssignmentDto[]>(
      `${GATEWAY_URL}/wapi/admins/manage/assignment`
    );
    return Promise.resolve(resp.data);
  }
  async createAssingment(
    option: CreateOrUpdateAllowIPDto
  ): Promise<AssignmentDto> {
    const resp = await axiosAdmin.post<AssignmentDto>(
      `${GATEWAY_URL}/wapi/admins/manage/assignment/create`,
      option
    );
    return Promise.resolve(resp.data);
  }
  async updateAssingment(
    option: CreateOrUpdateAllowIPDto
  ): Promise<AssignmentDto> {
    const resp = await axiosAdmin.post<AssignmentDto>(
      `${GATEWAY_URL}/wapi/admins/manage/assignment/update`,
      option
    );
    return Promise.resolve(resp.data);
  }
  async deleteAssingment(deleteIds: string[]): Promise<AssignmentDto[]> {
    const resp = await axiosAdmin.post<AssignmentDto[]>(
      `${GATEWAY_URL}/wapi/admins/manage/assignment/delete`,
      deleteIds
    );

    return Promise.resolve(resp.data);
  }
}
const adminSettingApi: AdminSettingApi = new AdminLoginServerApi();
export default adminSettingApi;
